/* eslint-disable */
import * as THREE from 'three'
import a from './r.js'
import r1 from './r1.js'
import r from './rr.js'
import c from './b.js'
import u from './f.js'
import s from './island1.js'
import l from './island2.js'

let _iii = 0;
let _yyy = 0;

function getY () {
  if (_iii > 359) _iii = 0

  const y = Math.cos(2 * Math.PI / 360 * _iii) * 10
  _iii += 1

  return _yyy + y
}

var d = function (e) {
  function o(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, o);
    var t = e.querySelector("canvas")
      , n = function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, "island", t, {}));
    n.ref = e,
      n.canvas = t,
      n.canvasOffsetTop = n.canvas.offsetTop,
      n.mouseRatio = {
        x: 0,
        y: 0
      },
      n.ratio = {
        x: 0,
        y: 0
      };

    // 这里要做动画
    // texture-island-cut-p2.png
    var i = new THREE.PlaneGeometry(1024, 512)
      , r = new THREE.MeshBasicMaterial({
        map: c.default.get("/images/texture-island-building-p2.png"),
        transparent: !0
      });
    return n.building = new u.default(i, r, {
      ox: -50,
      oy: 208,
      depth: -23
    }),
      n.bg = new s.default("texture-island-cut-p2.png", "map-island-cut-p2.jpg", {
        w: 2048,
        h: 512,
        intensity: -.085,
        smooth: .02
      }),
      n.ship = new s.default("ship.png", "map-island-cut-p2.jpg", {
        w: 2048,
        h: 512,
        intensity: -.085,
        smooth: .02
      }),
      n.water = new l.default("texture-island-water-p2.jpg", "map-island-water-p2.jpg", {
        w: 2048,
        h: 577,
        intensity: -.1,
        smooth: .02
      }),
      n.app.scene.add(n.building),
      n.app.scene.add(n.water),
      n.app.scene.add(n.bg),
      n.app.scene.add(n.ship),
      n.water.position.z = -2,
      n.resize(),
      n.render(),
      n
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(o, a.default),
    r1(o, [{
      key: "render",
      value: function () {
        this.visibleOffset = Math.max(0, window.currentScrollTop + 590 - this.offsetTop),
          this.mouseRatio.x = window.mouse.x / this.view.width * 2 - 1,
          this.mouseRatio.y = window.mouse.y / this.view.height * 2 - 1,
          this.ratio.x += .05 * (this.mouseRatio.x - this.ratio.x),
          this.ratio.y += .05 * (this.mouseRatio.y - this.ratio.y),
          this.building.parallax(this.ratio, !1),
          this.bg.render(1 - this.visibleOffset / window.h * 2 * -1)

          if (this.ship.position.x > 0) this.ship.position.x -= 1
          this.ship.position.y = getY()

          this.ship.render(1 - this.visibleOffset / window.h * 2 * -1),
          this.water.render(),
          r(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "render", this).call(this)
      }
    }, {
      key: "resize",
      value: function () {
        this.locate();
        var e = this.bg.image.width
          , t = window.w / e
          , n = window.w
          , i = 803 * t >> 0;
        this.building.resize(t),
          this.bg.resize(),
          this.ship.resize(),
          this.water.resize(),
          this.bg.position.y = 265 * t,
          this.ship.position.x = window.w / 2,
          this.ship.position.y = 260 * t,
          _yyy = this.ship.position.y,
          this.water.position.y = -270 * t,
          this.app.resize(n, i),
          this.canvasOffsetTop = this.canvas.offsetTop,
          this.ref.style.height = i + this.canvasOffsetTop + "px"
      }
    }, {
      key: "dispose",
      value: function () {
        this.app.scene.remove(this.building),
          this.app.scene.remove(this.bg),
          this.app.scene.remove(this.water),
          this.building.dispose(),
          this.building = null,
          this.bg.dispose(),
          this.bg = null,
          this.ship.dispose(),
          this.ship = null,
          this.water.dispose(),
          this.water = null,
          this.app.dispose(),
          this.app = null,
          this.mouseRatio = {
            x: 0,
            y: 0
          },
          this.ratio = {
            x: 0,
            y: 0
          },
          r(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "dispose", this).call(this)
      }
    }]),
    o
}();
export default d
